import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'
import { Identification } from '../../../../components/icons/Icons.js';

const GovernmentIds = ({ data }) => {
    return <Row> 
        <Col sm="6" className='mt-4'>
            <div className="employee-app">
                <Card className="employee-card position-relative overflow-hidden">
                    <Card.Header className="d-flex align-items-center justify-content-start gap-2">
                         <div className="employee-bullet">
                            <Identification class_name="text-purple" />
                        </div>
                        <div className="employee-title text-purple">Identity Details</div>
                    </Card.Header>
                    <Card.Body className="">
                        <Row className="gy-4">
                            <Col md={6}>
                                <div className="d-flex flex-column gap-2">
                                    <div>
                                        <div className="employee-label">Aadhar Name:</div>
                                        <div className="employee-value">{data.governmentIds?.aadhar_name || "-"}</div>
                                    </div>
                                    <div>
                                        <div className="employee-label">Aadhar Number:</div>
                                        <div className="employee-value">{data.governmentIds?.aadhar_number || "-"}</div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="d-flex flex-column gap-2">
                                    <div>
                                        <div className="employee-label">Driving License:</div>
                                        <div className="employee-value">{data.governmentIds?.driving_license || "-"}</div>
                                    </div>
                                    <div className="employee-branch">
                                        <div className="employee-label">ESI Number:</div>
                                        <div className="employee-value">{data.governmentIds?.esi_number || "-"}</div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

            </div>
        </Col>

        <Col sm="6" className='mt-4'>
            <div className="employee-app">
                <Card className="employee-card position-relative overflow-hidden">
                    <Card.Header className="d-flex align-items-center justify-content-start gap-2">
                        <div className="employee-bullet">
                            <Identification class_name="text-purple" />
                        </div>
                        <div className="employee-title text-purple">Identity Details</div>
                    </Card.Header>
                    <Card.Body className="">
                        <Row className="gy-4">
                            <Col md={6}>
                                <div className="d-flex flex-column gap-2">
                                    <div>
                                        <div className="employee-label">PAN Name:</div>
                                        <div className="employee-value">{data.governmentIds?.pan_name || "-"}</div>
                                    </div>
                                    <div>
                                        <div className="employee-label">PAN Number:</div>
                                        <div className="employee-value">{data.governmentIds?.pan_number || "-"}</div>
                                    </div>
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="d-flex flex-column gap-2">
                                    <div>
                                        <div className="employee-label">Passport Number:</div>
                                        <div className="employee-value">{data.governmentIds?.passport_number || "-"}</div>
                                    </div>
                                    <div className="employee-branch">
                                        <div className="employee-label">PF Number:</div>
                                        <div className="employee-value">{data.governmentIds?.pf_number || "-"}</div>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

            </div>
        </Col>
    </Row>
}

export default GovernmentIds